export const packList = [
"lorcana_Archazia's Island.json",
"lorcana_Azurite Sea.json",
"lorcana_Into the Inklands.json",
"lorcana_Rise of the Floodborn.json",
"lorcana_Shimmering Skies.json",
"lorcana_The First Chapter.json",
"lorcana_Ursula's Return - Deep Trouble.json",
"lorcana_Ursula's Return.json",
];